import React from "react"
import { Link } from "gatsby"

export const BlogBio = () => {
  return (
    <div className="bio">
      <p>
        Written by <b>Aravind Sanjeev</b>, an India-based blogger and web
        developer. <Link to="/">Read all his posts</Link>. You can also find him
        on <a href="https://www.twitter.com/aravsanj">twitter</a>.
      </p>
    </div>
  )
}
